import { isScoreTextElement } from "./escapeRoomScoreText";

const ELEMENT_LAYER_TYPE_LABELS = {
	text: "Texto",
	image: "Imagen",
	video: "Vídeo",
	audio: "Audio",
	quiz: "Pregunta",
	shape: "Forma",
	button: "Botón",
	hint: "Pista",
};

function getElementLayerSubtitle(el, quizzes = []) {
	if (!el) return "";
	if (el.type === "text") {
		if (isScoreTextElement(el.content)) return "Puntuación del jugador";
		const t = (el.content?.html || "").replace(/<[^>]+>/g, " ").replace(/\s+/g, " ").trim();
		return t.length > 40 ? `${t.slice(0, 40)}…` : t || "Caja de texto";
	}
	if (el.type === "quiz") {
		const q = quizzes.find((x) => String(x?._id) === String(el.content?.quizId || ""));
		return q?.fullName ? String(q.fullName).slice(0, 44) : "Sin pregunta asignada";
	}
	if (el.type === "button") return (el.content?.label || el.content?.text || "Acción").toString().slice(0, 44);
	if (el.type === "hint") return (el.content?.title || "Pista").toString().slice(0, 44);
	if (el.type === "shape") return (el.content?.shapeType || "forma").toString();
	if (el.type === "image") return el.content?.src || el.content?.url ? "Imagen" : "Imagen (sin archivo)";
	if (el.type === "video") return el.content?.src || el.content?.url ? "Vídeo" : "Vídeo (sin archivo)";
	if (el.type === "audio") return el.content?.url ? "Audio" : "Audio (sin archivo)";
	return el.type || "";
}

export { ELEMENT_LAYER_TYPE_LABELS, getElementLayerSubtitle };
